<template>
	<svg
		width="12"
		height="11"
		viewBox="0 0 12 11"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M4.97352 11V0H6.45813V11H4.97352ZM0.21582 6.23855V4.76145H11.2158V6.23855H0.21582Z"
			fill="#212121"
			opacity=".4"
		/>
	</svg>
</template>

<script>
export default {
	name: 'PlusInactive',
};
</script>
